import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const secureScanServices = {
  refreshSecureScan,
  getTotalScannedList,
  getSingleItemScanReport,
};

// Refresh Secure Scan
async function refreshSecureScan(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}refreshSecureScan`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// get Total Scanned List
async function getTotalScannedList(auth, searchData, page, length) {
  try {
    const signal = cancelPreviousRequest("getTotalScannedList");
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getTotalScannedList?search=${searchData || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getTotalScannedList?search=${searchData || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// get Single Item Scan Report
async function getSingleItemScanReport(auth, id) {
  try {
    const signal = cancelPreviousRequest("getSingleItemScanReport");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleItemScanReport/${id}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}